module.exports = __webpack_public_path__ + "img/icon-check.f5e4d45e.svg";